import { Card, CardContent } from "@exhousing/design-system";

export function PlaceholderPage({ title }: { title: string }) {
  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl font-medium tracking-tight">{title}</h1>
      <Card>
        <CardContent className="py-16 text-center text-muted-foreground">
          <p className="text-sm">
            {title} arrives in an upcoming phase of the build.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
